import { useNavigate } from "react-router-dom";
import "admin-lte/dist/css/adminlte.min.css";
import {
  loadResx,
  createTranslator,
} from "../../shared/helpers/resourceLoader";
import apiManager from "../../api/apiManager";
import API_ENDPOINTS from "../../api/apiEndpoints";
import { useSelectedDealership } from "../../hooks/useLocalStorage";
import { showErrorMessage } from "../../shared/Services/toasterService";
import {
  showLoader,
  hideLoader,
} from "../../shared/Services/Loader/loaderService";
import { useState, useEffect } from "react";
import { useLocalization } from "../../context/LocalizationContext";
import getUserRoleFromJWT from "../../shared/helpers/getUserRoleFromJWT";
import { UserRole } from "../../shared/Enums/UserRole";

const ServiceDeskDashboard = () => {
  const navigate = useNavigate();
  const { t: localization } = useLocalization();
  const [selectedDealershipId] = useSelectedDealership();
  const [customersCount, setCustomersCount] = useState(0);
  const [repairOrdersCount, setRepairOrdersCount] = useState(0);
  const [repairOrdersInProgressCount, setRepairOrdersInProgressCount] =
    useState(0);
  const userRole = getUserRoleFromJWT();

  useEffect(() => {
    DashboardDataCount();
  }, [selectedDealershipId]);

  const DashboardDataCount = async () => {
    try {
      showLoader();
      const payload = {};
      if (selectedDealershipId) {
        payload.id = selectedDealershipId;
      }

      const response = await apiManager.post(
        API_ENDPOINTS.DASHBOARD_GET,
        payload,
      );
      if (response.status == 200) {
        const data = response.data;

        setCustomersCount(data.customersCount || 0);
        setRepairOrdersCount(data.repairOrdersCount || 0);
        setRepairOrdersInProgressCount(data.repairOrdersInProgressCount || 0);
      } else {
        showErrorMessage(localization("failed_fetch_dashboard_data"));
      }
    } catch (error) {
      showErrorMessage(localization("error_occurred"));
    } finally {
      hideLoader();
    }
  };

  if (userRole === UserRole.SERVICE_DESK_USER && !selectedDealershipId) {
    return (
      <div className="dealer-admin">
        <div className="content-wrapper ">
          <div className="alert-warning text-center dealer-not-assigned">
            <div className="icon">
              <img
                src="../assets/images/illustrations/lock-icon.svg"
                alt="Dealer Not Assigned Icon"
              />
            </div>
            <h5>You are not assigned to any Shop</h5>
            <p>Please contact Administration.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">
          <div className="dashboard-content">
            <div className="dashboard-card start-service bg-white">
              <div className="dashboard-card-header">
                <h4 className="dashboard-card-title">
                  {localization("new_service_orders")}
                </h4>
              </div>
              <div className="icon">
                <img
                  src="assets/images/dashboard/card-icons/new-service-orders-icon.svg"
                  alt={localization("service_orders") + " Icon"}
                />
              </div>
              <div className="dashboard-card-body">
                <h5 className="middle-title">{repairOrdersCount}</h5>
                <p>{localization("created_today")}</p>
              </div>
              <div className="dashboard-card-footer">
                <button
                  className="btn card-btn bg-sky-blue text-white"
                  onClick={() =>
                    navigate("/second-step", { state: { reset: true } })
                  }
                >
                  {localization("start_service")}{" "}
                  <i className="fa-solid fa-circle-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
            <div className="dashboard-card active-service bg-white">
              <div className="dashboard-card-header">
                <h4 className="dashboard-card-title">
                  {localization("active_service_orders")}
                </h4>
              </div>
              <div className="icon">
                <img
                  src="assets/images/dashboard/card-icons/service-order-icon.svg"
                  alt={localization("service_orders") + " Icon"}
                />
              </div>
              <div className="dashboard-card-body">
                <h5 className="middle-title">{repairOrdersInProgressCount}</h5>
                <p>{localization("in_progress")}</p>
              </div>
              <div className="dashboard-card-footer">
                <button
                  className="btn card-btn bg-vibrant-green text-white"
                  onClick={() =>
                    navigate("/repair-orders", {
                      state: { statusFilter: "inprogress" },
                    })
                  }
                >
                  {localization("active_service")}
                  <i className="fa-solid fa-circle-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
            <div className="dashboard-card manage-service bg-white">
              <div className="dashboard-card-header">
                <h4 className="dashboard-card-title">
                  {localization("customers")}
                </h4>
              </div>
              <div className="icon">
                <img
                  src="assets/images/dashboard/card-icons/customers-icon.svg"
                  alt={localization("customers") + " Icon"}
                />
              </div>
              <div className="dashboard-card-body">
                <h5 className="middle-title">{customersCount}</h5>
                <p>{localization("customers")}</p>
              </div>
              <div className="dashboard-card-footer">
                <button
                  className="btn card-btn bg-vivid-red text-white"
                  onClick={() => navigate("/customer")}
                >
                  {localization("manage")}{" "}
                  <i className="fa-solid fa-circle-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDeskDashboard;
